// src/services/fleetHealthService.js
//
// Reads the fleet snapshot the backend assembles. Note what is NOT here: any
// derivation of online/degraded/offline. The backend decides the status and this
// only carries it, so the pill and the alert email can never disagree.

import { API_URL } from '../config.js';

/** Poll interval for the fleet view. Paused while the tab is hidden. */
export const HEALTH_POLL_MS = 20000;

/**
 * Tints only -- these mirror the backend thresholds so a cell can be shaded,
 * but they never decide the pill. Keep them equal to the backend's
 * DISK_WARN_PCT / DATA_STALE_SECONDS, or a cell will look fine while the pill
 * says degraded (or the reverse), which is exactly the confusion this pairs
 * with fixing on the server side.
 */
export const DISK_WARN_PCT = 10;
export const DATA_STALE_SEC = 300;

export async function fetchFleetHealth({ signal } = {}) {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_URL}/admin/plants/health`, {
    headers: { Authorization: `Bearer ${token}` },
    signal,
  });

  if (!res.ok) {
    throw new Error(`Fleet health request failed (${res.status})`);
  }

  const body = await res.json();
  // Defensive: the view must not explode if the shape is ever unexpected.
  return Array.isArray(body) ? body : [];
}

export default { fetchFleetHealth, HEALTH_POLL_MS, DISK_WARN_PCT, DATA_STALE_SEC };
